import React from 'react'
import Policy from './Policy'
import PriceBanner from './PriceBanner'
import PriceTable from './PriceTable'

function Price_en() {
  return (
    <main>
      <PriceBanner />
      <PriceTable />
      {/* <Policy /> */}
    </main>
  )
}

export default Price_en